/**
 * LD Localization Selector JavaScript
 * ===================================
 * 
 * Handles dropdown functionality for language and country/currency selectors
 * Clean, accessible implementation with keyboard navigation
 */

class LDLocalizationSelector {
  constructor() {
    this.init();
  }

  init() {
    // Find all localization selectors
    const selectors = document.querySelectorAll('.ld-localization-selector');
    
    selectors.forEach(selector => {
      const toggle = selector.querySelector('.ld-localization-selector__toggle');
      const dropdown = selector.querySelector('.ld-localization-selector__dropdown');
      
      if (toggle && dropdown) {
        this.setupSelector(toggle, dropdown, selector);
      }
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.ld-localization-selector')) {
        this.closeAllDropdowns();
      }
    });

    // Handle escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAllDropdowns();
      }
    });
  }

  setupSelector(toggle, dropdown, container) {
    // Toggle dropdown on button click
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.closeDropdown(toggle, dropdown);
      } else {
        this.closeAllDropdowns();
        this.openDropdown(toggle, dropdown);
      }
    });

    // Handle keyboard navigation
    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle.click();
      }
    });

    // Handle dropdown keyboard navigation
    const options = dropdown.querySelectorAll('.ld-localization-selector__option');
    options.forEach((option, index) => {
      option.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            const nextOption = options[index + 1] || options[0];
            nextOption.focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            const prevOption = options[index - 1] || options[options.length - 1];
            prevOption.focus();
            break;
          case 'Escape':
            event.preventDefault();
            this.closeDropdown(toggle, dropdown);
            toggle.focus();
            break;
        }
      });
    });
  }

  openDropdown(toggle, dropdown) {
    toggle.setAttribute('aria-expanded', 'true');
    if (window.innerWidth <= 1120) {
      dropdown.classList.add('is-open');
      dropdown.style.display = 'flex';
      // Не трогаем hidden, чтобы transition работал
    } else {
      dropdown.hidden = false;
    }
    // Focus first option for keyboard navigation
    const firstOption = dropdown.querySelector('.ld-localization-selector__option');
    if (firstOption) {
      setTimeout(() => firstOption.focus(), 0);
    }
  }

  closeDropdown(toggle, dropdown) {
    toggle.setAttribute('aria-expanded', 'false');
    if (window.innerWidth <= 1120) {
      dropdown.classList.remove('is-open');
      // Ждём окончания transition, потом скрываем display
      setTimeout(() => {
        if (!dropdown.classList.contains('is-open')) {
          dropdown.style.display = 'none';
        }
      }, 350); // чуть больше transition
    } else {
      dropdown.hidden = true;
    }
  }

  closeAllDropdowns() {
    const toggles = document.querySelectorAll('.ld-localization-selector__toggle[aria-expanded="true"]');
    toggles.forEach(toggle => {
      const dropdown = toggle.nextElementSibling;
      if (dropdown && dropdown.classList.contains('ld-localization-selector__dropdown')) {
        this.closeDropdown(toggle, dropdown);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LDLocalizationSelector();
  });
} else {
  new LDLocalizationSelector();
} 